import Header from 'components/navigation/Header';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ConditionHistory from '../condition/ConditionHistory';
import MedicationHistory from '../medications/medicationHistory/MedicationHistory';
import MyTabs from './MyTabs';

export default function HistoryTabs(props) {
  const params = useParams();
  const tab = params.tab === 'cond' ? 1 : 0;
  //console.log('HistoryTabs', tab)
  
  const [currentTab, setCurrentTab] = useState(tab);

  const tabList = ['Medications', 'Conditions'];
  const tabStyle = 'font-semibold text-xl';

  function onTabChange(n) {
    setCurrentTab(n);
  }

  return (
    <div className='mcard'>
      {/* <div className='mcard-screen'>History</div> */}
      <Header title='History' add={null} />
      <MyTabs tabList={tabList} currentTab={currentTab} onTabChange={onTabChange} />
      <>
      {currentTab === 0 && <MedicationHistory />}
      {currentTab === 1 && <ConditionHistory />}
      </>
    </div>
  );
}
